import News from "../components/news/News";

const NewsPage = () => {
  return <News />;
};

export default NewsPage;
